module.exports = __webpack_public_path__ + "0ddb797a0b4996c9f2817d3071a3c9d6.svg";